import React, { useState, useEffect } from "react";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import AboutusBG from "../../../Assets/AboutUs_Img/about_background_img.webp";
import { Link } from "react-router-dom";
import ultra_clear from "../../../Assets/Product_Page/ultra_clear.webp";
import features_img from "../../../Assets/Product_Page/features_img.webp";
import applications from "../../../Assets/Product_Page/applications.webp";
import features_1 from "../../../Assets/Product_Page/features_1.webp";
import features_2 from "../../../Assets/Product_Page/features_2.webp";
import features_3 from "../../../Assets/Product_Page/features_3.webp"; // New feature image
import applications_1 from "../../../Assets/Product_Page/applications_1.webp";
import applications_2 from "../../../Assets/Product_Page/applications_2.webp";
import applications_3 from "../../../Assets/Product_Page/applications_3.webp";
import applications_4 from "../../../Assets/Product_Page/applications_4.webp";
import applications_5 from "../../../Assets/Product_Page/applications_5.webp";

import api from "../../../api/api";

const UltraClear = () => {
  const [clearGlassData, setClearGlassData] = useState({});
  const [activeTab, setActiveTab] = useState("features");

  const featureImages = [
    features_1, 
    features_2, 
    features_3,

  ];
  
  const applicationImages = [
    applications_1, 
    applications_2, 
    applications_3,
    applications_4, 
    applications_5,
  ];
  

  useEffect(() => {
    api.get("/ultra-clear-glass") // Ensure this route matches with your Laravel route
      .then((res) => {
        console.log(res.data);
        setClearGlassData(res.data[0]); // Set the fetched data into state
      })
      .catch((err) => {
        console.error("Error fetching Ultra Clear Glass data", err);
      });
  }, []);

  const title = clearGlassData.title || 'Ultra Clear'; 

  return (
    <div>
      <Header />

      {/* Banner section */}
      <section
        className="container-fluid common_banner"
        style={{
          backgroundImage: `url(${AboutusBG})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="common_title wow fadeInUp">
                <h1>
                  <Link
                    to="/Product"
                    className="text-decoration-none text-white"
                  >
                    PRODUCTS / {title}
                  </Link>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Ultra Clear Glass Section */}
      <section className="container-fluid clear_sction">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="clear_text">
                <img src={ultra_clear} alt="Ultra Clear" />
                <h5>{title}</h5>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features & Applications Tab Section */}
      <section className="container-fluid features_section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="tabs">
                <div className="tab-buttons">
                  <button
                    className={`tab-btn ${activeTab === "features" ? "active" : ""}`}
                    onClick={() => setActiveTab("features")}
                  >
                    <img src={features_img} alt="Features" /> Features
                  </button>
                  <button
                    className={`tab-btn ${activeTab === "applications" ? "active" : ""}`}
                    onClick={() => setActiveTab("applications")}
                  >
                    <img src={applications} alt="Applications" /> Applications
                  </button>
                </div>

                {/* Features Tab */}
                {activeTab === "features" && (
                  <div id="features" className="tab-content active">
                    <ul>
                      {clearGlassData.features && clearGlassData.features.map((feature, index) => (
                        <li key={index}>
                          {/* Dynamically cycle through feature images */}
                          <img
                            src={featureImages[index % featureImages.length]} // Use modulus to loop through images
                            alt={`Feature ${index + 1}`}
                          />
                          {feature}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                {/* Applications Tab */}
                {activeTab === "applications" && (
                  <div id="applications" className="tab-content active">
                    <ul>
                      {clearGlassData.applications && clearGlassData.applications.map((app, index) => (
                        <li key={index}>
                          {/* Dynamically cycle through application images */}
                          <img
                            src={applicationImages[index % applicationImages.length]} // Use modulus to loop through images
                            alt={`Application ${index + 1}`}
                          />
                          {app}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default UltraClear;
